import { render, staticRenderFns } from "./PersonIcon.vue?vue&type=template&id=5ff0793f&scoped=true&lang=pug&"
import script from "./PersonIcon.vue?vue&type=script&lang=js&"
export * from "./PersonIcon.vue?vue&type=script&lang=js&"
import style0 from "./PersonIcon.vue?vue&type=style&index=0&id=5ff0793f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff0793f",
  null
  
)

export default component.exports